import { Response, Server } from 'miragejs';
import { AUTHORIZATION, AUTHORIZATION_MODEL, IDENTITY_PROVIDER, IDENTITY_PROVIDER_MODEL } from '../data/util';
import { Authorization } from '../model/entity.model';
import { AuthorizationData } from '../model/routes.model';
import { AppSchema } from '../model/typings.model';

export function initializeAuthorizationRoutes(server: Server, data: AuthorizationData): void {
  server.get(AUTHORIZATION, (schema: AppSchema) => {
    const authorization = schema.findBy(
      AUTHORIZATION_MODEL,
      (auth: Authorization) => auth.fullName === data.providerName
    );
    return authorization === null ? new Response(401, {}, { errors: ['no auth found'] }) : { ...authorization.attrs };
  });
  server.get(IDENTITY_PROVIDER, (schema: AppSchema) => {
    return schema.all(IDENTITY_PROVIDER_MODEL).models;
  });
}
